import { NewCase } from '../common/new-case/new-case';
import { AddressInfo } from './AddressInfo';

export class UserInfo {
    apportisUserId: number;
    userId: number;
    firstName: string;
    lastName: string;
    nickName: string;
    email: string;
    password: string;
    isActive: boolean;
    phone: string;
    gender: string;
    addressId: number;
    address: AddressInfo;
    telemedicineUsername: string;
    clinical_org_id: number;
    roleId: number;
    roleName: string;
    clinics: number[];
    clinicsNotinAppuser?: number[];
    profileImageUrl: string;
    timeZone: string;
    license: any;
    emergencyContact: string;
    emergencyPhone: string;
    emergencyContactRelation: number;
    isClientAppointmentBook: boolean;
    abbreviation: string;
    officeHours: string;
    officeLocation: string;
    teleHealthHours: string;
    clinicians: number[];
    clinicianId: number[];
    clinicId: number[];
    dob: any;
    cliniciansNotInAppUser?: number[];
    orgType: string;
    displayName: string;
    // family
    relationDetail: any[];
    family_clients: any;
    relation: any;
    // profile
    countyId: number;
    newCase = new NewCase();
    // variable for clinic/clinician single dropdown
    clinic = 0;
    clinician = 0;
    checked: boolean;
    // Social Worker
    socialWorkers: number[];
    socialWorker = 0;
    secondaryRoles: number[];
    secondaryRoleClinician = 0;
    userName: string;
    countryCodeId: number;
}
